import {FileItemStatus} from '../types';

import type {MouseEventHandler} from 'react';

import type {FileItem, FileUploaderProps} from '../types';

export type UploadedFileProps<T> = {
  item: FileItem<T>;
} & Pick<FileUploaderProps<T>, 'disabled' | 'onClick' | 'onDelete' | 'maxLabelLength' | 'maxLabelLengthFunc'>;

export function useUploadedFile<T>(props: UploadedFileProps<T>) {
  const item = props.item;
  const status = item.status;
  const disabled = props.disabled || item.disabled;

  const isHidden = status === FileItemStatus.Deleted;
  const isError = status === FileItemStatus.Error;

  const isLoading = [FileItemStatus.Loading, FileItemStatus.Deleting].includes(status);

  const isDeletable =
    !isLoading &&
    !disabled &&
    !!props.onDelete &&
    [FileItemStatus.Initial, FileItemStatus.Loaded, FileItemStatus.Error].includes(status);

  const isClickable = !disabled && (!!props.onClick || !!item.url);

  const onClick: MouseEventHandler = e => {
    e.stopPropagation();

    props.onClick?.(item, e);
  };

  const onDelete = () => props.onDelete?.(item);

  return {
    isHidden,
    isError,
    isLoading,

    onClick: isClickable ? onClick : undefined,
    onDelete: isDeletable ? onDelete : undefined,
  };
}
